import { render, staticRenderFns } from "./ElectronicFAQ.vue?vue&type=template&id=3bc07833&scoped=true"
import script from "./ElectronicFAQ.vue?vue&type=script&lang=js"
export * from "./ElectronicFAQ.vue?vue&type=script&lang=js"
import style0 from "./ElectronicFAQ.vue?vue&type=style&index=0&id=3bc07833&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc07833",
  null
  
)

export default component.exports